import React from 'react';
import { BookOpen, DollarSign, Users, TrendingUp } from 'lucide-react';

const FormationStats = ({ stats }) => {
  if (!stats) return null;

  const statCards = [
    {
      title: 'Total Formations',
      value: stats.total_formations || 0,
      icon: BookOpen,
      gradient: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-700'
    },
    {
      title: 'Formations Payantes',
      value: stats.formations_payantes || 0,
      icon: DollarSign,
      gradient: 'from-green-500 to-green-600',
      bgColor: 'bg-green-50',
      textColor: 'text-green-700'
    },
    {
      title: 'Formations Gratuites',
      value: stats.formations_gratuites || 0,
      icon: BookOpen,
      gradient: 'from-orange-500 to-orange-600',
      bgColor: 'bg-orange-50',
      textColor: 'text-orange-700'
    },
    {
      title: 'Total Inscriptions',
      value: stats.total_inscriptions || 0,
      icon: Users,
      gradient: 'from-purple-500 to-purple-600',
      bgColor: 'bg-purple-50',
      textColor: 'text-purple-700'
    }
  ];

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div
              key={index}
              className={`${stat.bgColor} rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100`}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-600 mb-1">
                    {stat.title}
                  </p>
                  <p className={`text-3xl font-bold ${stat.textColor}`}>
                    {stat.value}
                  </p>
                </div>
                <div className={`w-14 h-14 bg-gradient-to-br ${stat.gradient} rounded-xl flex items-center justify-center shadow-lg`}>
                  <Icon className="text-white" size={28} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Stats supplémentaires */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-gradient-to-br from-[#FF6B00] to-[#e55d00] rounded-lg flex items-center justify-center">
              <TrendingUp className="text-white" size={20} />
            </div>
            <div>
              <p className="text-sm text-gray-600">Cette semaine</p>
              <p className="text-2xl font-bold text-gray-900">{stats.formations_semaine || 0}</p>
            </div>
          </div>
          <p className="text-xs text-gray-500">Nouvelles formations</p>
        </div>

        <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-gradient-to-br from-[#437011] to-[#325a0d] rounded-lg flex items-center justify-center">
              <DollarSign className="text-white" size={20} />
            </div>
            <div>
              <p className="text-sm text-gray-600">Prix moyen</p>
              <p className="text-2xl font-bold text-gray-900">{stats.prix_moyen || 0} FCFA</p>
            </div>
          </div>
          <p className="text-xs text-gray-500">Formations payantes</p>
        </div>
      </div>
    </div>
  );
};

export default FormationStats;
